import React from 'react';
import Background from '../components/Background';

const TermAndConditions = () => (
    <>
    
    <div className='w-1/2 z-20 p-8 bg-white'>
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
        <a href="/Resumen Terminos y Condiciones Generales.pdf" target='_blank' style={{ textDecoration: 'none', color: 'blue' }}>
          [ Ver Resumen ]
        </a>
      </div>
      <title>
        Landing Digipayments - Terminos y Condiciones Generales de Usuario
      </title>
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            ' * {margin:0; padding:0; text-indent:0; }\n h1 { color: black; font-family:Calibri, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 12pt; }\n .p, p { color: black; font-family:Calibri, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; margin:0pt; }\n .a, a { color: black; font-family:Calibri, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n .s2 { color: black; font-family:Calibri, sans-serif; font-style: italic; font-weight: normal; text-decoration: none; font-size: 12pt; }\n li {display: block; }\n #l1 {padding-left: 0pt;counter-reset: c1 1; }\n #l1> li>*:first-child:before {counter-increment: c1; content: counter(c1, decimal)". "; color: black; font-family:Calibri, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 12pt; }\n #l1> li:first-child>*:first-child:before {counter-increment: c1 0;  }\n li {display: block; }\n #l2 {padding-left: 0pt;counter-reset: d1 10; }\n #l2> li>*:first-child:before {counter-increment: d1; content: counter(d1, decimal)". "; color: black; font-style: normal; font-weight: normal; text-decoration: none; }\n #l2> li:first-child>*:first-child:before {counter-increment: d1 0;  }\n #l3 {padding-left: 0pt;counter-reset: d2 1; }\n #l3> li>*:first-child:before {counter-increment: d2; content: counter(d2, lower-latin)") "; color: black; font-family:Calibri, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n #l3> li:first-child>*:first-child:before {counter-increment: d2 0;  }\n li {display: block; }\n #l4 {padding-left: 0pt;counter-reset: e1 16; }\n #l4> li>*:first-child:before {counter-increment: e1; content: counter(e1, decimal)". "; color: black; font-family:Calibri, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 12pt; }\n #l4> li:first-child>*:first-child:before {counter-increment: e1 0;  }\n #l5 {padding-left: 0pt;counter-reset: e2 1; }\n #l5> li>*:first-child:before {counter-increment: e2; content: counter(e1, decimal)"."counter(e2, decimal)". "; color: black; font-family:Calibri, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n #l5> li:first-child>*:first-child:before {counter-increment: e2 0;  }\n li {display: block; }\n #l6 {padding-left: 0pt;counter-reset: f1 1; }\n #l6> li>*:first-child:before {counter-increment: f1; content: counter(f1, decimal)". "; color: black; font-family:Calibri, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n #l6> li:first-child>*:first-child:before {counter-increment: f1 0;  }\n'
        }}
      />
      <h1
        style={{
          paddingTop: "1pt",
          textIndent: "0pt",
          textAlign: "center"
        }}
      >
        Términos y Condiciones Generales de Digipayments S.A.U.
      </h1>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <ol id="l1">
        <li data-list-text={1}>
          <h1
            style={{
              paddingLeft: "41pt",
              textIndent: "-36pt",
              textAlign: "justify"
            }}
          >
            Contenido de los Términos y Condiciones.
          </h1>
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Este documento contiene los términos y condiciones (“<u>T&amp;C</u>”)
            que rigen la relación entre Digipayments S.A.U. (“<u>Digipayments</u>
            <a
              href="http://www.digipayments.com.ar/"
              className="a"
              target="_blank"
              rel="noreferrer"
            >
              ”) y los usuarios que acceden o utilizan el sitio web https://www
            </a>
            .digipayments.com.ar (“<u>Sitio Web</u>”)
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text={2}>
          <h1
            style={{
              paddingLeft: "17pt",
              textIndent: "-12pt",
              textAlign: "justify"
            }}
          >
            Servicios ofrecidos por Digipayments
          </h1>
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Digipayments puede ofrecer a los usuarios, a través del Sitio Web, los
            servicios de (i) provisión de cuentas de pago (la “
            <u>Cuenta de Pago</u>”); (ii) envío y recepción de transferencias
            inmediatas, (por ejemplo la emisión de tarjetas prepagas, etc.) (“
            <u>Servicios</u>”).
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            La creación de la Cuenta de Pago implicará la creación y vinculación
            automática de una Clave Virtual Uniforme (CVU) para poder enviar y
            recibir transferencias inmediatas.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Digipayments ofrece servicios de pago y se encuentra inscripto como
            Proveedor de Servicios de Pago ante el Banco Central de la República
            Argentina (“<u>BCRA</u>”). Digipayments no se encuentra autorizado
            para operar como entidad financiera por el BCRA.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Los fondos depositados en cuentas de pago no constituyen depósitos en
            una entidad financiera, ni cuentan con ninguna de las garantías que
            tales depósitos puedan gozar de acuerdo con la legislación y
            reglamentación aplicables en materia de depósitos en entidades
            financieras.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text={3}>
          <h1
            style={{
              paddingLeft: "17pt",
              textIndent: "-12pt",
              textAlign: "justify"
            }}
          >
            Aceptación de estos T&amp;C para utilización de los Servicios.
          </h1>
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            <a
              href="http://www.digipayments.com.ar/privacy-policy"
              className="a"
              target="_blank"
              rel="noreferrer"
            >
              Cualquier usuario deberá aceptar estos T&amp;C y la Política de
              Privacidad para utilizar los Servicios. Esa aceptación por parte del
              usuario lo vinculará con Digipayments mediante un contrato
              legalmente válido. Si bien el usuario puede ingresar a la Política
              de Privacidad haciendo clic en el siguiente link: https://www
            </a>
            .digipayments.com.ar/privacy-policy, le adelantamos que ese documento
            contiene las cláusulas sobre el uso y recopilación de cierta
            información del usuario, su dispositivo o su comportamiento en línea.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "justify"
            }}
          >
            Si usted no acepta estos T&amp;C o la Política de Privacidad, no podrá
            usar los Servicios.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text={4}>
          <h1
            style={{
              paddingLeft: "17pt",
              textIndent: "-12pt",
              textAlign: "justify"
            }}
          >
            Riesgo de uso del Sitio Web.
          </h1>
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            El uso del Sitio Web le representará riesgos por el mero uso de
            internet o de los dispositivos electrónicos.
          </p>
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Digipayments no garantiza el acceso y uso continuado o ininterrumpido
            del Sitio Web ni de los Servicios ya que estos pueden eventualmente no
            estar disponibles debido a dificultades técnicas o fallas de internet
            en los links o por cualquier otra circunstancia ajena a Digipayments.
            Cuando ocurra una falla de ese tipo Digipayments informará a los
            usuarios, en la medida de lo posible, y adoptará las medidas de
            prevención razonables que tenga a su alcance. Esas medidas podrían
            implicar la suspensión de los Servicios o el acceso al Sitio Web. Los
            usuarios deben comprender que esas medidas se realizan de buena fe y
            por el bien de los usuarios.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Asimismo, el usuario podrá elegir libremente el dispositivo en el cual
            acceda al Sitio Web y deberá dirigir el reclamo ante el responsable de
            ese dispositivo por cualquier defecto o inconveniente técnico que
            presente ese dispositivo.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Digipayments no puede garantizar que el Sitio Web y los canales de
            comunicación con el usuario se encuentren en todo momento libre de
            virus, spyware, troyanos, gusanos o cualquier otro elemento que pueda
            llegar a tomar conocimiento de su información sin su consentimiento,
            dañar o destruir sus dispositivos electrónicos, tomar control de su
            Cuenta, o alterar su normal funcionamiento (“<u>Elementos Dañinos</u>
            ”). Es responsabilidad y obligación del usuario contar con los
            antivirus, programas de software y herramientas adecuadas para
            detectar, prevenir y neutralizar cualquier tipo de Elemento Dañino.
            Digipayments no será responsable por ningún daño que pueda sufrir el
            usuario como consecuencia o en relación con Elementos Dañinos o
            correos electrónicos falsos o que aparenten provenir de Digipayments
            que sean enviados por terceros (“<i>phishing”) </i>sin relación con
            Digipayments.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text={5}>
          <h1
            style={{
              paddingLeft: "17pt",
              textIndent: "-12pt",
              textAlign: "justify"
            }}
          >
            Requisitos para utilización de los Servicios
          </h1>
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Además de aceptar estos T&amp;C y las Políticas de Privacidad, para
            poder utilizar los Servicios ofrecidos por Digipayments a través del
            Sitio Web usted deberá haber cumplido 18 años y no estar declarado
            judicialmente como incapaz o tener la capacidad restringida para
            contratar o disponer de su patrimonio. Aunque es responsabilidad del
            usuario cumplir con este requisito, Digipayments podrá pedirle cierta
            documentación que acredite estos extremos.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            No podrán volver a utilizar el Sitio Web y, por ende, no tendrán
            acceso a los Servicios los usuarios que hayan sido suspendidos
            temporalmente o inhabilitados definitivamente por Digipayments en los
            casos enumerados en estos términos y condiciones, salvo autorización
            expresa y por escrito de Digipayments.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Si los Servicios estuviesen disponibles para personas jurídicas
            registradas como usuarios en el Sitio Web, la persona humana que
            utilice los Servicios deberá tener capacidad y haber sido
          </p>
          <p
            style={{
              paddingTop: "1pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            investida de poderes de representación suficientes para contratar a
            nombre de tal entidad, de disposición de sus bienes y de obligarla
            bajo estos T&amp;C. Digipayments podrá solicitar la documentación
            pertinente que acredite dichas circunstancias.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Ninguna persona podrá utilizar el Sitio Web ni los Servicios en
            calidad de comerciante, locador o prestador de servicios, a los
            efectos de la Resolución General 4636 de la Administración Federal de
            Ingresos Públicos y sus normas modificatorias y complementarias.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            El usuario declara y acepta que utilizará el Sitio Web y los Servicios
            solamente con fines personales, no comerciales.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text={6}>
          <h1
            style={{
              paddingLeft: "17pt",
              textIndent: "-12pt",
              textAlign: "justify"
            }}
          >
            Registro para uso del Sitio Web
          </h1>
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Para acceder a los Servicios ofrecidos por Digipayments es necesario
            que se haya registrado previamente en el Sitio Web, completando con
            datos válidos e información personal exacta, precisa, completa,
            actualizada y verdadera (“<u>Datos Personales</u>”) . Usted deberá
            mantener actualizados sus Datos Personales y es responsable por
            cualquier inexactitud que presenten.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Sin perjuicio de ello, Digipayments, en cualquier caso, podría
            solicitarle cierta documentación que acredite la información
            entregada, así como suspender los Servicios si usted no logra
            acreditar la información requerida.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            El usuario autoriza a Digipayments y a sus afiliadas a verificar los
            datos suministrados con bases de entidades públicas, compañías
            especializadas y centrales de riesgo, incluyendo sin limitación al
            Registro Nacional de las Personas (RENAPER).
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Además, Digipayments es sujeto obligado ante la Unidad de Información
            Financiera (“<u>UIF</u>”) conforme a su Resolución 76/2019,
            modificatorias y complementarias. En función de ello, y en
            cumplimiento de las regulaciones vigentes en materia de Prevención del
            Lavado de Dinero y Financiamiento del Terrorismo (“<u>PLD/FT</u>”),
            Digipayments se encuentra obligado a recabar cierta información y
            documentación del usuario, la cual deberá mantenerse actualizada, para
            dar cumplimiento a procesos de identificación, verificación,
            conocimiento y monitoreo de los mismos y su operatoria, que podrá
            variar, de acuerdo con la actividad del usuario dentro del Sitio Web,
            o de los Servicios que el usuario utilice.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "justify"
            }}
          >
            Digipayments utilizará la Información para los siguientes fines: a)
            identificación y autenticación,
          </p>
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            b) administración y gestión comercial, c) mejora del servicio, d)
            fines estadísticos, e) envío de notificaciones, promociones o
            publicidad, entre otros, y f) lo estipulado en la política de
            privacidad.
          </p>
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            El usuario autoriza expresamente a Digipayments a compartir la
            información brindada al momento del registro y verificación de su
            cuenta (incluyendo dirección de e-mail) con instituciones financieras
            en caso de ser requeridas por procedimientos de PLD/FT y/o prevención
            de fraude y con los proveedores de servicios o las empresas afiliadas
            que contribuyan a dar servicio y/o mejorar o facilitar las operaciones
            a través del Sitio Web en todas las jurisdicciones donde el servicio
            se encuentre disponible, sin limitarse a medios de pago, medios de
            colección de pago, entidades financieras, seguros o intermediarios en
            la gestión de pagos, call centers, entidades que intervengan en la
            resolución de disputas, que pueden incluir, entre otros, Compañías de
            Seguros, Amigables Componedores o Tribunales de Arbitraje o tribunales
            competentes. Digipayments velará porque se cumplan ciertos estándares
            en la trasmisión de la información, mediante la firma de acuerdos o
            convenios cuyo objeto sea la privacidad y confidencialidad de los
            datos personales de los usuarios.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Asimismo el Usuario consiente y autoriza expresamente que toda la
            información y datos personales proporcionados a Digipayments,
            relacionados a la utilización de ciertos servicios (como por ejemplo
            el Servicio de CVU), puedan ser transferidos por parte de Digipayments
            a los terceros prestadores de los Servicios y/o cualquier empresa
            relacionada a éstos.
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "justify"
            }}
          >
            A su vez Digipayments consiente y autoriza expresamente para que
            Compensadora Electrónica
          </p>
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            S.A. o la cámara electrónica de compensación que en su futuro la
            reemplace o aquella otra que el Banco Central de la República
            Argentina autorice a actuar como cámara electrónica de compensación de
            bajo valor, transfiera al Banco Industrial S.A. o al Banco que lo
            reemplace y a Digipayments las Claves Bancarias Uniformes (CBUs) y las
            Claves Virtuales Uniformes (CVUs) de todas las cuentas bancarias
            virtuales y a la vista a nombre de los usuarios de Digipayments y
            demás información o datos personales relacionados que tenga en su
            poder.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text={7}>
          <h1
            style={{
              paddingLeft: "17pt",
              textIndent: "-12pt",
              textAlign: "justify"
            }}
          >
            Utilización de los Servicios.
          </h1>
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Digipayments protege a sus usuarios de buena fe limitando la
            registración de ciertas personas que podrían utilizar los Servicios de
            mala fe. Así, con el objetivo de proteger a la masa de usuarios de
            buena fe, Digipayments no admitirá el registro o suspenderá uno
            vigente en todos los casos en los cuales identifique que un usuario, o
            si correspondiere, o sus accionistas, subsidiarias, controladas,
            directores, funcionarios, empleados o agentes son personas que se
            encuentren situadas en, constituidas en, o sean residentes de un país
            o territorio cuyo gobierno esté sujeto a Sanciones, incluyendo sin
            limitaciones: la Región de Crimea, Cuba, Irán, Siria y Corea del
            Norte. A los efectos de esta cláusula, se entenderá por “Sanciones” a
            las restricciones o prohibiciones en la capacidad de participar en
            negocios y otras actividades económicas con ciertos países, regiones,
            personas o entidades, o cualquier medida gubernamental emitida con el
            fin de privar a una entidad (incluyendo individuos, corporaciones,
            territorios, países, etc.) de
          </p>
          <p
            style={{
              paddingTop: "1pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            activos financieros y económicos con el fin de contrarrestar e
            intentar reducir el comportamiento que amenace la seguridad nacional o
            internacional o contravenga el derecho internacional. En particular,
            serán rechazados como usuarios o suspendidos o inhabilitados quienes
            se encuentren incluidos en las Listas de Sancionados de OFAC (Office
            of Foreign Assets Control de Estados Unidos) y listas de terroristas
            de las Naciones Unidas, así como en cualquier lista nacional de
            personas bloqueadas, quedando prohibido el registro del usuario o la
            utilización del Sitio Web en los mencionados territorios o
            jurisdicciones sancionadas.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Tampoco podrán registrarse como usuarios las personas humanas o
            jurídicas sobre las que disponga de información de la que surja que
            pueden estar relacionadas con actividades de naturaleza delictiva,
            especialmente aquellos supuestamente vinculados al narcotráfico, al
            terrorismo, o al crimen organizado en general.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            En virtud de lo previsto en la presente cláusula, Digipayments podrá
            rechazar una solicitud de registro o cancelar, suspender o impedir,
            temporal o definitivamente una Cuenta, o el acceso o uso de los
            Servicios por parte de cualquier usuario (i) ante incongruencias o
            inconsistencias en la información provista por un usuario, o
            actividades inusuales o sospechosas del usuario en materia de
            prevención de lavado de dinero y financiamiento al terrorismo o de
            fraude; o (ii) en caso que el usuario no proporcione o no actualice en
            tiempo y forma la información o documentación requerida; (iii) en caso
            de que el usuario se encuentre sujeto a Sanciones, o situado en,
            constituido en, o sea residente en un país o territorio sujeto a
            Sanciones, con el alcance previsto en esta cláusula; (iv) en caso de
            que el Usuario estuviese o pudiese estar relacionado con actividades
            de naturaleza delictiva, según lo previsto en esta cláusula; (v) en
            caso de que Digipayments identifique actividades sospechosas o
            ilícitas o no permitidas por las prácticas y buenas costumbre de la
            industria, o (vi) o cuando Digipayments considere que el usuario viola
            total o parcialmente estos T&amp;C. En ningún caso la decisión de
            Digipayments generará para el usuario derecho a ser resarcido ni
            indemnizado en ningún modo ni por concepto alguno. Aclaramos que en
            estos casos podría no otorgarse preaviso o expresión de causa como
            parte de la adopción de las medidas razonables para evitar que se
            produzcan mayores daños de conformidad con lo previsto por el art.
            1710 del Código Civil y Comercial.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text={8}>
          <h1
            style={{
              paddingLeft: "17pt",
              textIndent: "-12pt",
              textAlign: "justify"
            }}
          >
            Cuenta. Uso de la Cuenta.
          </h1>
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Luego de registrarse en el Sitio Web, se abrirá una cuenta de pago que
            le permitirá al usuario utilizar los Servicios de Digipayments, junto
            con cualquier otra funcionalidad que en un futuro se ofrezca al
            usuario, sujeto a los términos y condiciones que se establezcan para
            cada funcionalidad (“<u>Cuenta</u>”).
          </p>
          <p
            style={{
              paddingTop: "1pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            El usuario podrá acceder a la Cuenta con una dirección de correo
            electrónico o nombre de usuario, una contraseña y, de ser activado, un
            doble factor de autenticación. El acceso a la Cuenta con el ingreso
            del correo electrónico o nombre de usuario y contraseña surtirá el
            efecto de firma, como firma electrónica, con relación a todas las
            operaciones que el usuario realice a través del Sitio Web.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            La Cuenta es personal, única e intransferible, y será asignada en
            forma individual a cada usuario. Está prohibida su venta, cesión o
            transferencia bajo cualquier título. El usuario se compromete a no
            permitir ni autorizar el uso de su Cuenta por terceros, y a no crear
            más de una Cuenta. El usuario se obliga a mantener la confidencialidad
            de su contraseña y la seguridad de los dispositivos con los que accede
            a su Cuenta, y consecuentemente será el único y exclusivo responsable
            por todas las operaciones efectuadas desde cualquier dispositivo que
            emplee su Cuenta. El usuario se compromete a notificar a Digipayments
            sobre cualquier ingreso, intento de ingreso, o uso no autorizado de su
            Cuenta, en forma inmediata y por medio fehaciente o a través de
            cualquiera de los canales de comunicación disponibles desde el Sitio
            Web.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Asimismo, el usuario declara y reconoce que todas las tarjetas de
            débito, crédito y cuentas bancarias y de pago que asocie a su Cuenta
            son de su titularidad.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text={9}>
          <h1
            style={{
              paddingLeft: "17pt",
              textIndent: "-12pt",
              textAlign: "justify"
            }}
          >
            El servicio. Orden de Gestión. Mandato
          </h1>
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Para poder acceder a los Servicios dentro de el Sitio Web, los
            usuarios podrán realizar distintas solicitudes para que Digipayments
            gestione operaciones conforme las instrucciones impartidas por cada
            usuario (“<u>Orden de Gestión”</u>), a fin de realizar operaciones en
            pesos argentinos por cuenta y orden del usuario.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Las Órdenes de Gestión cursadas por los Usuarios implican (i) una
            autorización a favor de Digipayments para disponer en su nombre de
            ciertos fondos de su Cuenta de Pago y transferirlos a la cuenta del
            destinatario designado de acuerdo con sus instrucciones; y (ii) una
            autorización del usuario a favor de Digipayments para recibir y
            acreditar en su Cuenta de Pago los fondos de acuerdo con sus
            instrucciones. Digipayments liquidará, acreditará y mantendrá los
            fondos del usuario en su Cuenta de Pago en las condiciones y plazos
            establecidos en estos T&amp;C.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            El usuario acepta que Digipayments podrá, en cualquier momento,
            establecer o modificar límites al número de Órdenes de Gestión a
            emitirse por los usuarios y a sus montos, incluyendo, sin limitación,
            los límites que dispongan cualesquiera políticas de prevención de
            lavado de activos y financiamiento del terrorismo, políticas de
            Digipayments u otras que resulten aplicables.
          </p>
          <p
            style={{
              paddingTop: "1pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Toda solicitud se perfeccionará mediante el envío por parte del
            usuario de una Orden de Gestión en línea detallando las instrucciones
            en relación a los fondos. Digipayments se reserva el derecho de no
            procesar aquella Orden de Gestión que esté incompleta o en la cual
            haya discrepancia entre los datos provistos por los usuarios y los
            datos ingresados efectivamente en el Sitio Webo porque Digipayments lo
            considere necesario. El usuario es el único y exclusivo responsable
            por las Órdenes de Gestión y sus consecuencias. Digipayments no
            verificará la causa u obligación que originó la Orden de Gestión, ni
            las demás circunstancias relativas a ella. Las Órdenes de Gestión sólo
            podrán efectuarse a través del Sitio Web según lo previsto en estos
            T&amp;C, y ninguna instrucción cursada será procesada ni reputada
            válida si se realiza por otros medios ajenos a los aquí previstos.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            La Orden de Gestión no se considerará perfeccionada y Digipayments no
            asumirá responsabilidad u obligación alguna bajo la Orden de Gestión
            hasta tanto (i) Digipayments no haya aceptado la Orden de Gestión del
            usuario, aclarándose que Digipayments podrá negarse a cumplir con la
            Orden de Gestión, por ejemplo si la misma es contraria a estos T&amp;C
            o una normativa local o si la Orden de Gestión supera los límites
            determinados en el Sitio Web, y por ello no podrá imputarse
            responsabilidad alguna; y (ii) se encuentren disponibles en la Cuenta
            de Pago la totalidad de los fondos necesarios para perfeccionar una
            Orden de Gestión.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            El usuario es el exclusivo responsable de cada Orden de Gestión y sus
            consecuencias, y reconoce que Digipayments no verificará el negocio
            subyacente a la Orden de Gestión, ni su causa, finalidad o
            circunstancias, ni la capacidad de los contratantes. El usuario es el
            único responsable por cualquier error (incluyendo, sin limitación,
            errores de tipeo —incluso los referidos al monto o al destinatario—,
            reenvío de formularios y duplicación de órdenes) que pueda haber
            cometido al completar y/o emitir una Orden de Gestión e indemnizará y
            mantendrá indemne a Digipayments, accionistas, directivos, empleados
            y/o representantes por cualquier daño que tales errores pudiesen
            directa o indirectamente generarle al propio usuario, a Digipayments,
            accionistas, directivos, empleados y/o representantes o terceros. Es
            asimismo responsabilidad del usuario todo lo concerniente a los
            impuestos aplicables a las operaciones que realice con el Sitio Web,
            por lo que Digipayments no será responsable sobre notificaciones,
            pagos o cualesquiera otras obligaciones del usuario ante las
            autoridades competentes.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            El usuario asume, reconoce y acepta su total responsabilidad por las
            pérdidas que se originen, en especial si a través de su nombre de
            usuario se ordenaran instrucciones fraudulentas, duplicadas, no
            autorizadas o meramente erróneas, así como por los eventuales
            perjuicios que pueda causar a Digipayments.
          </p>
          <p
            style={{
              paddingTop: "1pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            El usuario declara conocer y asumir todos los riesgos de que terceros
            no autorizados accedan a la información correspondiente a su Cuenta,
            siempre que no haya existido dolo o culpa grave de Digipayments.
            Digipayments realiza sus mejores esfuerzos técnicos a los efectos de
            que la información incluida en el sistema mantenga el más alto grado
            de confidencialidad posible.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Digipayments no será responsable ni garantizará el cumplimiento de las
            obligaciones que hubiesen asumido los usuarios con terceros en
            relación con las trasnsferencias a efectuar a través del Sitio Web. El
            usuario reconoce y acepta que al realizar transacciones u operaciones
            con otros usuarios o terceros lo hace por su propia voluntad,
            prestando su consentimiento libremente y bajo su propio riesgo y
            responsabilidad. En virtud de que Digipayments es ajeno a la
            obligación que dio origen a la Orden de Gestión, Digipayments no será
            responsable ni verificará las causas, importe o cualquier otra
            circunstancia relativa a dicha Orden de Gestión, así como respecto de
            la existencia, calidad, cantidad, funcionamiento, estado, integridad o
            legitimidad de los bienes o servicios ofrecidos, adquiridos por los
            usuarios y pagados utilizando el Sitio Web, así como de la capacidad
            para contratar de los usuarios y la veracidad de los datos personales
            por ellos ingresados.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text={10}>
          <h1
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Los Fondos
          </h1>
        </li>
      </ol>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}>
        10. <i>(i) Ingreso de fondos</i>
      </p>
      <p
        style={{
          paddingTop: "2pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "justify"
        }}
      >
        El usuario al registrarse en el Sitio Web declara mantener una Cuenta de
        Pago activa y acuerda, acepta y autoriza recibir fondos que oportunamente
        envíe el propio usuario u otras personas a su Cuenta de Pago y que se le
        debite cualquier cargo que pueda resultar aplicable.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "justify"
        }}
      >
        Los usuarios pueden ingresar dinero en su Cuenta de Pago mediante (i)
        operaciones de transferencias “push” (ya sea desde cuentas de misma
        titularidad o de un tercero) a las CVU asignadas al momento de creación de
        la Cuenta de Pago y (ii) cualquier otra forma habilitada a tal fin.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "justify"
        }}
      >
        Los fondos se acreditarán en la Cuenta de Pago del usuario conforme a las
        tarifas y plazos de liquidación que resulten aplicables, debiéndose
        acreditar de manera inmediata los fondos ingresados a través de
        transferencias a su CVU. El usuario podrá disponer de los fondos
        acreditados para realizar las operaciones habilitadas.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        className="s2"
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        10.(ii)<span className="p">. Retención de Fondos.</span>
      </p>
      <p
        style={{
          paddingTop: "1pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "justify"
        }}
      >
        Los Fondos que se acrediten en la Cuenta de Pago del usuario y/o que estén
        pendientes de liquidación podrán permanecer retenidos cuando, a exclusivo
        criterio de Digipayments y por cuestiones de seguridad, existan fuertes
        sospechas de ilegalidades, fraude, excesiva cantidad de operaciones o
        transacciones fraudulentas o excesivos pedidos de devoluciones o
        contracargos, o cualquier otro acto contrario a estos T&amp;C o que
        levante sospechas de violación a la normativa aplicable.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "justify"
        }}
      >
        El usuario reconoce y acepta que los ingresos de fondos deben responder a
        fines no comerciales.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}>
        100. <i>(iii) Fondos acreditados</i>
      </p>
      <p
        style={{
          paddingTop: "2pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "justify"
        }}
      >
        Luego de realizarse un ingreso de fondos, Digipayments acreditará tales
        fondos en la Cuenta de Pago y se encontrarán disponibles para que el
        usuario pueda utilizarlos conforme se detalla en los presentes Términos.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "justify"
        }}
      >
        Digipayments mantendrá los fondos disponibles de las Cuentas en cuentas a
        la vista a su nombre en entidades financieras del sistema financiero
        argentino de su elección. Digipayments no será responsable en ningún caso
        por la insolvencia de la entidad financiera donde tenga hechos los
        depósitos.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "justify"
        }}
      >
        El usuario acepta que la existencia de fondos en su Cuenta por cualquier
        lapso no lo hará beneficiario de rendimientos de ningún tipo, salvo
        estipulación expresa en contrario.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "justify"
        }}
      >
        A fin de (1) prevenir daños a Digipayments, afiliadas, accionistas,
        directivos, empleados y/o representantes y/o a terceros, y resarcirlos en
        caso de que ocurran, (2) prevenir el lavado de dinero, el financiamiento
        del terrorismo y otros delitos, y/o (3) colaborar con las autoridades
        competentes en la investigación de delitos o potenciales delitos, el
        usuario está de acuerdo con todo lo siguiente: sin perjuicio de tomar las
        medidas de naturaleza civil, administrativa y penal que pudiesen
        corresponder, si Digipayments sospechara, a su solo criterio, que la
        Cuenta estuviera siendo utilizada (i) en relación con actos ilícitos o
        (ii) de modo contrario a estos T&amp;C, el usuario acepta que Digipayments
        podrá suspender temporalmente la disposición de la totalidad o parte de
        los fondos disponibles en la Cuenta de Pago, sin perjuicio de otras
        medidas previstas en estos T&amp;C o habilitadas por las normas vigentes.
        Asimismo, el usuario acepta que cualesquiera operaciones relacionadas con
        los ítems (i) y (ii) precedentes serán nulas, y que Digipayments y
        cualquiera de sus afiliadas podrán, por sí mismas o por terceros, sin
        necesidad de previo aviso al usuario, revertir cualesquiera efectos o
        consecuencias que esas operaciones nulas hubiesen directa o indirectamente
        ocasionado.
      </p>
      <p
        style={{
          paddingTop: "1pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "justify"
        }}
      >
        Todo movimiento de fondos vinculado a la Cuenta, realizados por los
        usuarios se verán reflejados en la actividad de la Cuenta de cada uno de
        éstos.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "justify"
        }}
      >
        Toda información sobre el estado de los fondos en la Cuenta debe ser
        siempre verificada por el usuario a través del Sitio Web mediante el
        ingreso de sus credenciales. Digipayments y sus sociedades relacionadas no
        serán responsables por las conductas del usuario que se originen o
        vinculen con información contenida en correos electrónicos falsos o que
        aparenten provenir de Digipayments que sean enviados por terceros sin
        relación con éste ni sus sociedades relacionadas como así tampoco
        responderán por cualquier consecuencia dañosa derivada de tales conductas,
        ni por la circulación de los mencionados correos electrónicos falsos.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}>
        10. <i>(iv) Egreso de fondos</i>
      </p>
      <p
        style={{
          paddingTop: "2pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "justify"
        }}
      >
        Una vez que los fondos estén acreditados y disponibles en su Cuenta de
        Pago, el usuario podrá
      </p>
      <p
        style={{
          paddingTop: "2pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "justify"
        }}
      >
        (i) mantener los fondos en su Cuenta de Pago para utilizarlos a su libre
        disponibilidad o (ii) retirar o utilizar los fondos para transferencias a
        otras cuentas bancarias propias o de terceros, a otras cuentas de pago
        propias o de terceros.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "justify"
        }}
      >
        Las transferencias serán ordenadas de manera inmediata, y para la
        realización de las transferencias se utilizarán los canales más eficientes
        que se encuentren disponibles para transferencias de fondos en el sistema
        nacional de pagos minorista. Cualquier costo asociado a las transferencias
        estará a cargo del usuario. El usuario reconoce y acepta que las
        transferencias ordenadas a través de el Sitio Web se encuentran
        supeditadas al normal funcionamiento y cumplimiento de las autorizaciones
        de los participantes del sistema nacional de pagos involucrados, y al
        cumplimiento de las normas de la Unidad de Información Financiera, Banco
        Central de la República Argentina y cualquier otra entidad que participe o
        regule el mercado.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "justify"
        }}
      >
        Por razones de seguridad de la masa de usuarios de buena fe, Digipayments
        podrá bloquear las transferencias, retiros o extracciones de fondos
        solicitados por aquellos usuarios en los que se hayan detectado o haya
        serios indicios o sospechas de que los mismos han utilizado el Sitio Web
        para realizar actividades fraudulentas, ilícitas o en contra de estos
        T&amp;C o en violación de alguna regulación.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}>
        10. <i>(v) Límites</i>
      </p>
      <p
        style={{
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "justify"
        }}
      >
          Digipayments puede determinar o modificar diferentes límites de las
          distintas operaciones que estarán informados en las respectivas
          operaciones y/o en la sección correspondiente.
      </p>
      <p
        style={{
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "justify"
        }}
      >
          Facultades de Digipayments. Límites. Comunicación de Operaciones.
          Digipayments reitera que cumple rigurosamente con toda ley y normativa
          emanada de las autoridades locales que regulan la actividad de
          Digipayments. En ese sentido, realiza las comunicaciones necesarias
          requeridas por los organismos locales. Los Usuarios al adherir a los
          presentes T&amp;C, asumen, en forma personal e intransferible, la
          responsabilidad integral por sus declaraciones y declaran que poseen
          capacidad económica para transaccionar en los volúmenes pretendidos,
          teniendo Digipayments la facultad de, en cualquier momento, solicitar
          al usuario la comprobación fehaciente acerca de su capacidad
          financiera, bajo pena, a criterio de Digipayments, de reducir el
          límite concedido u otras medidas que sean legalmente posibles de ser
          adoptadas.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <ol id="l2">
        <li data-list-text={10}>
          <p
            className="s2"
            style={{
              paddingLeft: "22pt",
              textIndent: "-17pt",
              textAlign: "justify"
            }}
          >
            (vi) <span className="p">Consentimiento.</span>
          </p>
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
              El usuario al registrarse en la Plataforma y crearse su cuenta de pago brinda el consentimiento
              para que Digipayments ejecute las transferencias que ordene. El consentimiento se mantendrá vigente
              ante toda transferencia ordenada por el usuario a través de la Plataforma.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text={11}>
          <h1
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Comisiones
          </h1>
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            El usuario acepta que Digipayments podrá cobrarle una comisión por la
            prestación de Servicios relacionados a cualquiera de las operaciones
            en pesos, equivalente a un porcentaje del monto de cada operación, que
            será debitado de la Cuenta al efectuarse cada operación. Los
            porcentajes están publicados en el Sitio Web. Digipayments podrá
            modificar en cualquier momento y de forma unilateral los porcentajes
            de las comisiones y su forma de pago. Cualquier cambio en el esquema
            de comisiones será publicado en el Sitio Web y notificado a los
            usuarios por alguno de los canales digitales disponibles con una anticipación
            previa a su entrada en vigencia mínima de 60 (sesenta) días corridos.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "justify"
            }}
          >
            Comisiones por depósitos o retiros:
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "justify"
            }}
          >
            Por transferencia bancaria: 0% final.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            <a
              href="http://www.bcra.gob.ar/BCRAyVos/Regimen_de_transparencia.asp"
              className="a"
              target="_blank"
              rel="noreferrer"
            >
              Usted puede consultar el “Régimen de Transparencia” elaborado por el
              Banco Central de la República Argentina (BCRA) sobre la base de la
              información proporcionada por los sujetos obligados a fin de
              comparar los costos, características y requisitos de los productos y
              servicios financieros, ingresando a{" "}
            </a>
            <a
              href="http://www.bcra.gob.ar/BCRAyVos/Regimen_de_transparencia.asp"
              target="_blank"
              rel="noreferrer"
            >
              http://www.bcra.gob.ar/BCRAyVos/Regimen_de_transparencia.asp.
            </a>
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text={12}>
          <h1
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Uso de el Sitio Web
          </h1>
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            11.1. Consideraciones generales sobre la utilización del Sitio Web. El
            usuario se compromete a utilizar el Sitio Web de conformidad con la
            ley, estos T&amp;C , así como con la moral y buenas costumbres
            generalmente aceptadas por el mercado y el orden público. El usuario
            se obliga a abstenerse de utilizar el Sitio Web con fines o efectos
            ilícitos, contrarios a lo establecido en estos T&amp;C, lesivos de los
            derechos e intereses de terceros, o que de cualquier forma puedan
            dañar, inutilizar, sobrecargar o deteriorar el Sitio Web o impedir su
            normal utilización por parte de otros usuarios.
          </p>
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            12.2. Los medios de incorporación o extracción de fondos son los
            especificados en el Sitio Web. Digipayments no opera con otros medios
            que no sean los listados en el Sitio Web. A los efectos del presente
            se considerará efectuada la operación en los términos del Código Civil
            y Comercial de la Nación a aquellas realizadas a través de los medios
            autorizados y no serán considerados válidos los desembolsos en
            efectivo ni la utilización de otros medios distintos a los
            autorizados. Digipayments no responderá por los perjuicios o
            inconvenientes ocasionados al usuario en virtud del mal uso o
            conflicto entre el usuario y el medio elegido.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            12.3. Ante cualquier infracción por parte del usuario de los presentes
            T&amp;C, Digipayments puede tomar la decisión de devolver los fondos
            almacenados en su cuenta a través de una transferencia bancaria o
            cualquier otro medio permitido en el Sitio Web, reteniendo los gastos
            administrativos correspondientes (por ejemplo: comisiones de los
            servicios de carga de saldo, comisiones de la mencionada transferencia
            bancaria, etc.).
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text={13}>
          <h1
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Prohibiciones al usuario
          </h1>
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "left"
            }}
          >
            Sin que la lista sea exhaustiva, el usuario se obliga a abstenerse de
            realizar las siguientes acciones, ya sea directamente o a través de un
            tercero:
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <ol id="l3">
            <li data-list-text="a)">
              <p
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "114%",
                  textAlign: "justify"
                }}
              >
                utilizar el Sitio Web, los servicios o cualquiera de sus
                contenidos de un modo o con fines que Digipayments, a su solo
                criterio, considere distinto o contrarios a estos T&amp;C, las
                leyes, la moral, las buenas costumbres o el orden público;
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </li>
            <li data-list-text="b)">
              <p
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "114%",
                  textAlign: "justify"
                }}
              >
                utilizar el Sitio Web, los servicios o cualquiera de sus
                contenidos para enviar, reproducir o publicar archivos o cualquier
                tipo de información cuyo contenido sea obsceno, abusivo,
                difamatorio, injurioso, pornográfico, político o contrario a las
                leyes, la moral y las buenas costumbres, o que contenga software
                malicioso como virus, bugs o que contenga cualquier otra
                característica capaz de destruir o dañar el funcionamiento de un
                dispositivo electrónico, del Sitio Web, o de los sistemas o
                servidores de Digipayments y/o de sus afiliadas o de un tercero;
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </li>
            <li data-list-text="c)">
              <p
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "114%",
                  textAlign: "justify"
                }}
              >
                utilizar el Sitio Web, los servicios o cualquiera de sus
                contenidos para enviar, reproducir o publicar archivos en
                violación a derechos de propiedad intelectual de terceros;
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </li>
            <li data-list-text="d)">
              <p
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "114%",
                  textAlign: "justify"
                }}
              >
                explotar o aprovechar de mala fe un ataque al Sitio Web, o una
                vulnerabilidad o un error del Sitio Web, en beneficio propio o de
                un tercero;
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </li>
            <li data-list-text="e)">
              <p
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "114%",
                  textAlign: "justify"
                }}
              >
                utilizar el Sitio Web, los servicios o cualquiera de sus
                contenidos en representación o por cuenta de terceros, o permitir
                a cualquier persona (incluyendo, sin limitación, a través de
              </p>
              <p
                style={{
                  paddingTop: "1pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "114%",
                  textAlign: "left"
                }}
              >
                cesión, licencia, transferencia o locación) utilizar la Cuenta o
                cualquiera de los servicios asociados a la misma, inclusive,
                cobrar por los servicios;
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </li>
            <li data-list-text="f)">
              <p
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "114%",
                  textAlign: "justify"
                }}
              >
                efectuar Órdenes de Gestión para realizar operaciones con tarjeta
                de crédito que constituyan o puedan entenderse como préstamos o
                adelantos de efectivo a sí mismo o a terceros, o como pasos de un
                proceso que culmine en, o implique, esas operaciones;
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </li>
            <li data-list-text="g)">
              <p
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "114%",
                  textAlign: "justify"
                }}
              >
                usar programas, software o dispositivos automáticos o manuales
                para monitorear o copiar la información o cualquier tipo de
                contenido o elemento del Sitio Web;
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </li>
            <li data-list-text="h)">
              <p
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "114%",
                  textAlign: "justify"
                }}
              >
                vincular de cualquier modo el Sitio Web o los servicios a
                promociones no solicitadas, campañas políticas o mensajes
                comerciales (SPAM) o a cualquier mensaje en cadena o contenido
                diseñado para engañar a, u obtener beneficios indebidos de,
                usuarios o terceros;
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </li>
            <li data-list-text="i)">
              <p
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "114%",
                  textAlign: "justify"
                }}
              >
                efectuar acciones que restrinjan, denieguen o impidan a cualquier
                individuo, grupo, entidad u organización, el acceso a, o uso del
                Sitio Web y de los contenidos, productos y servicios ofrecidos a
                través del Sitio Web;
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </li>
            <li data-list-text="j)">
              <p
                style={{
                  paddingLeft: "14pt",
                  textIndent: "-9pt",
                  textAlign: "justify"
                }}
              >
                intentar violar cualesquiera sistemas de autenticación y seguridad
                del Sitio Web;
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </li>
            <li data-list-text="k)">
              <p
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "114%",
                  textAlign: "justify"
                }}
              >
                intentar obtener cualquier clase de material o contenido accesible
                a través del Sitio Web empleando procedimientos o medios distintos
                de los que, según el caso, se hayan expresamente indicado o puesto
                a disposición del usuario;
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </li>
            <li data-list-text="l)">
              <p
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "114%",
                  textAlign: "justify"
                }}
              >
                incluir frames, links, deep links, o enlaces al Sitio Web, tanto
                desde otros sitios web como de cualquier software o dispositivo
                electrónico;
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </li>
            <li data-list-text="m)">
              <p
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "114%",
                  textAlign: "justify"
                }}
              >
                realizar cualquier acción que imponga una carga desproporcionada o
                desmesurada sobre la infraestructura tecnológica del Sitio Web;
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </li>
            <li data-list-text="n)">
              <p
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "114%",
                  textAlign: "justify"
                }}
              >
                utilizar meta tags o algún otro tipo de texto oculto con el nombre
                “Digipayments” o cualquier otro nombre o denominación comercial
                y/o derechos de propiedad intelectual que le pertenezcan o sean de
                titularidad de Digipayments o de sus licenciantes o afiliadas;
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </li>
            <li data-list-text="o)">
              <p
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "114%",
                  textAlign: "justify"
                }}
              >
                Realizar una factura dirigida a Digipayments, a menos que, entre
                el usuario y la Digipayments, se haya establecido un acuerdo
                comercial por el cual la Sociedad haya aceptado pagar por bienes o
                servicios. Toda factura emitida a nombre de Digipayments fuera del
                caso anterior, será nula.
              </p>
            </li>
          </ol>
        </li>
        <li data-list-text={14}>
          <h1
            style={{
              paddingTop: "2pt",
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Solicitud de baja o cierre de la Cuenta. Terminación. Cláusula de
            Revocación.
          </h1>
        </li>
      </ol>
      <p
        style={{
          paddingTop: "2pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "justify"
        }}
      >
        <a href="mailto:soporte@digipayments.com.ar" className="a" target="_blank" rel="noreferrer">
          El usuario puede solicitar la baja de la Cuenta a través del Sitio Web,
          o vía correo electrónico a{" "}
        </a>
        soporte@digipayments.com.ar únicamente desde la casilla de correo con la cual se
        registró.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "justify"
        }}
      >
        <a
          href="mailto:soporte@digipayments.com.ar"
          className="a"
          target="_blank"
          rel="noreferrer"
        >
          Digipayments podrá solicitar comprobantes e información adicional a
          efectos de corroborar la veracidad de la solicitud de baja y de la
          información suministrada por el usuario. Una vez que dicha solicitud se
          considere válida, Digipayments. procederá a la eliminación de las
          credenciales de acceso al Sitio Web. El número de documento y el correo
          electrónico asociados al usuario permanecerán bloqueados, de modo que
          ninguna otra persona, diferente al usuario, podrá crear una nueva Cuenta
          bajo dichos parámetros. La baja de la Cuenta implicará asimismo la
          terminación de este contrato entre el usuario y Digipayments. La
          información sobre transacciones no será eliminada. Los datos personales
          del usuario permanecerán en las bases de Digipayments y las empresas
          asociadas por un período de al menos cinco años corridos desde el
          momento del cierre de la Cuenta o por todo el tiempo que se considere
          que sea necesario o pertinente a los fines para los cuales han sido
          recolectados o aquel plazo legal que exista a tal fin. El usuario puede
          solicitar una copia de dicha información vía email a{" "}
        </a>
        soporte@digipayments.com.ar, únicamente desde la casilla de correo con el
        cual se registró, o vía carta documento válida a la dirección legal de
        Digipayments. Dicho reporte será entregado en el plazo estipulado
        legalmente o, de no estar establecido, en un plazo razonable que
        Digipayments determine, únicamente por email o vía carta documento al
        domicilio que el usuario disponga en la solicitud previamente mencionada.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "justify"
        }}
      >
        En caso de existir un saldo remanente en la Cuenta deberá ser retirado por
        el usuario previo al cierre de la Cuenta. Pero si, al momento del cierre,
        aún existiese saldo, será liquidado y entregado al usuario a través del
        medio seleccionado por el usuario e informado fehacientemente a
        Digipayments o a alguno de los medios que el usuario haya previamente
        utilizado para extraer fondos. No se podrá proceder al cierre de la cuenta
        si se mantiene saldo que no pueda ser devuelto al usuario por cualquier
        causa ajena a Digipayments.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}>
        Asimismo, el Usuario tiene derecho a revocar la aceptación del servicio
        dentro del plazo de diez
      </p>
      <p
        style={{
          paddingTop: "2pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "justify"
        }}
      >
        (10) días hábiles contados a partir de la fecha de recibido el contrato,
        notificando de manera fehaciente o por el mismo medio en que el servicio o
        producto fue contratado.
      </p>
      <p
        style={{
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "justify"
        }}
      >
        Dicha revocación será sin costo ni responsabilidad alguna para el Usuario,
        en la medida que no haya hecho uso del respectivo servicio y que, en el
        caso de que lo haya utilizado, sólo se le cobrarán las comisiones y cargos
        previstos para la prestación, proporcionados al tiempo de utilización del
        servicio.
      </p>
      <h1
        style={{
          paddingTop: "1pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "justify"
        }}
      >
        16. Créditos. Servicios de terceros. Uso de la información
      </h1>
      <p
        style={{
          paddingTop: "2pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "justify"
        }}
      >
        El usuario reconoce que Digipayments no otorga por sí mismas créditos de
        ningún tipo.
      </p>
      <p
        style={{
          paddingTop: "2pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "justify"
        }}
      >
        En general el usuario reconoce y acepta que los servicios que terceros
        puedan poner a disposición del usuario a través del Sitio Web pueden estar
        sujetos a términos, condiciones y restricciones específicas, incluyendo,
        pero no limitadas al resultado de análisis crediticios y la previa
        evaluación de la información y aprobación de la misma por parte del
        tercero. En virtud de que Digipayments no tiene control sobre tales
        terceros, no será responsable por los contenidos, materiales, acciones o
        servicios prestados por ellos, ni por daños o pérdidas directas o
        indirectas que se deriven de ellos. La presencia de enlaces a contenidos,
        sitios web o aplicaciones de terceros no implica una sociedad, relación,
        aprobación ni respaldo de Digipayments a esos terceros.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "justify"
        }}
      >
        Digipayments hará sus mejores esfuerzos para mantener la confidencialidad
        y seguridad de los usuarios, pero no responderá por perjuicios que se
        puedan derivar de la violación de dichas medidas por parte de terceros que
        utilicen las redes públicas o el Internet para acceder a dicha información
        o en los casos en que exista culpa o negligencia del usuario.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "justify"
        }}
      >
        <a
          href="http://www.digipayments.com.ar/privacy-policy"
          className="a"
          target="_blank"
          rel="noreferrer"
        >
          Puede acceder a la política de privacidad de Digipayments visitando la
          siguiente URL:{" "}
        </a>
        <a href="http://www.digipayments.com.ar/privacy-policy" target="_blank" rel="noreferrer">
          www.digipayments.com.ar/privacy-policy
        </a>
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <ol id="l4">
        <li data-list-text={16}>
          <h1
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Modificaciones a los T&amp;C
          </h1>
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Digipayments podrá modificar en cualquier momento estos T&amp;C con una anticipación
            previa a su entrada en vigencia mínima de 60 (sesenta) días corridos. El usuario será
            notificado de esas modificaciones a través de la publicación de los nuevos términos en el
            Sitio Web. Dentro de un plazo máximo de 60 (sesenta) días desde la publicación, el usuario
            puede comunicar a Digipayments (por cualquier canal de comunicación) que no acepta las
            mismas y, en ese caso, se comenzarán los trámites para disolver el vínculo contractual.
            Vencido este plazo de 60 días, se considerará que el usuario acepta los nuevos términos y
            condiciones.. De no estar de acuerdo con los nuevos términos, el usuario deberá dejar de
            acceder o usar el Sitio Web y los Servicios de Digipayments. En caso de modificaciones a
            características esenciales del servicio el usuario será notificado a través de la publicación de
            los nuevos términos en el Sitio Web y se le otorgará la posibilidad de aceptar o no los
            mismos. En caso de no aceptar los nuevos términos y, en caso de que sea necesario el
            consentimiento del usuario para la prestación de los Servicios, se procederá a deshabilitar
            parcial o totalmente el acceso a los Servicios y/o al cierre definitivo de la Cuenta.
            El usuario podrá cerrar su cuenta en Digipayments sin costo y sin que esto genere
            responsabilidad alguna hacia Digipayments (el usuario debe cumplir con todas sus
            obligaciones con Digipayments antes de proceder al cierre de su cuenta).
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            El Titular se reserva el derecho de realizar, en cualquier momento y
            sin necesidad de preaviso, cualquier modificación o actualización de
            sus contenidos y servicios en general, así como de cuantos elementos
            integren el diseño y configuración del Sitio Web.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text={17}>
          <h1
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Contenido. Propiedad intelectual
          </h1>
          <p
            style={{
              paddingTop: "1pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Todo el contenido del Sitio Web, incluyendo, pero no limitado, al
            diseño de sus pantallas, materiales promocionales, las marcas, nombres
            comerciales, signos distintivos, textos, gráficos, logos, imágenes,
            íconos, botones, videos, sonidos, música, bases de datos, código
            fuente, software y combinaciones de colores (en adelante, el
            “Contenido”), es de titularidad de Digipayments o de sus licenciantes.
            El Contenido no podrá ser reproducido, modificado, transformado,
            editado, traducido, cedido, distribuido, representado, comercializado,
            comunicado públicamente, almacenado, usado para fines distintos de los
            previstos en estos T&amp;C, ni ser objeto de obras derivadas, sin
            autorización previa y por escrito del titular de los derechos.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            El hecho de que el usuario pueda acceder al Sitio Web y a los
            Servicios no le otorga licencia, derecho ni titularidad alguna sobre
            los derechos de propiedad industrial o intelectual sobre la totalidad
            ni sobre porción alguna del Contenido. Solamente se otorga a los
            usuarios, sobre el Sitio Web, Servicios y sobre el Contenido, una
            licencia no exclusiva, revocable y limitada para acceder a, y usar el
            Sitio Web y Servicios de conformidad con estos T&amp;C.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Si el usuario considera que en el Sitio Web o en el Contenido se
            violara algún derecho de propiedad intelectual de terceros, deberá
            notificarlo a Digipayments a las direcciones indicadas en estos
            T&amp;C, acompañando toda la información y documentación necesaria que
            respalde la mencionada consideración.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text={18}>
          <h1
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Obligaciones fiscales y legales
          </h1>
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Cada usuario será responsable por todas las obligaciones y cargas
            impositivas que correspondan por sus operaciones en el Sitio Web, sin
            que pueda imputarse a Digipayments ningún tipo de responsabilidad
            derivada de los incumplimientos de los usuarios. Digipayments y/o sus
            afiliadas no se responsabilizan por el efectivo cumplimiento de las
            obligaciones fiscales o impositivas de sus usuarios, establecidas por
            la ley vigente y/o cualquier otra obligación que surja en virtud de lo
            celebrado entre los usuarios.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text={19}>
          <h1
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Responsabilidad.
          </h1>
          <ol id="l5">
            <li data-list-text="19.1.">
              <p
                style={{
                  paddingTop: "2pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "114%",
                  textAlign: "justify"
                }}
              >
                El usuario reconoce y acepta que utiliza los Servicios bajo su
                única y exclusiva responsabilidad. Cada usuario conoce y acepta
                ser el exclusivo responsable de su accionar dentro del Sitio Web.
                El usuario conoce y acepta que al realizar operaciones a través
                del Sitio Web lo hace bajo su propio riesgo. En ningún caso
                Digipayments y/o sus afiliadas serán responsables por lucro
                cesante, o por cualquier otro daño y/o perjuicio que haya podido
                sufrir el usuario, debido a las operaciones que se concreten a
                través del Sitio Web, ajenas al accionar de Digipayments.
                Digipayments no será responsable por la interacción de los
                usuarios basadas en la confianza depositada en el sistema o en el
                Sitio Web.
              </p>
            </li>
            <li data-list-text="19.2.">
              <p
                style={{
                  paddingTop: "2pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "114%",
                  textAlign: "justify"
                }}
              >
                Al aceptar estos Términos y Condiciones, el Usuario exonera a
                Digipayments y afiliadas, a sus accionistas, directores,
                representantes y/o empleados de cualquier responsabilidad derivada
                de acciones y/o demandas y/o indemnizaciones por daños de
                cualquier clase y/o naturaleza que tuviera origen o conexión en un
                enfrentamiento entre uno o más usuarios, que resulte ajeno al
                accionar de Digipayments.
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </li>
            <li data-list-text="19.3.">
              <p
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "114%",
                  textAlign: "justify"
                }}
              >
                Digipayments no garantiza la privacidad y seguridad de la
                utilización del Sitio Web y, en particular, no garantiza que
                terceros no autorizados no puedan tener conocimiento de la clase,
                condiciones, características y circunstancias del uso que los
                usuarios hacen del Sitio Web. Ni Digipayments y sus afiliadas
                garantizan que el Sitio Web funcionará libre de errores o que el
                Sitio Web y su servidor estén libres de los virus informáticos u
                otros mecanismos lesivos. Si por el uso del Sitio Web el usuario
                tiene que acudir al servicio técnico o reponer el equipo o datos,
                ni Digipayments ni sus afiliadas serán responsables de estos
                gastos. El Sitio Web se suministra tal como está disponible al
                usuario, sin garantías de ninguna clase. Ni el Digipayments ni sus
                afiliadas asumen garantías sobre la exactitud, veracidad,
                exhaustividad o actualización de los contenidos, los servicios, el
                software, los textos, los gráficos y los vínculos disponibles en
                ésta.
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </li>
            <li data-list-text="19.4.">
              <p
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "114%",
                  textAlign: "justify"
                }}
              >
                El Sitio Web puede contener enlaces a sitios web de terceros lo
                cual no indica que sean propiedad u operados por Digipayments o
                sus afiliadas, ni que tengan relación alguna con éste. En virtud
                de que Digipayments y sus afiliadas no tiene control sobre tales
                sitios, no serán responsables por los contenidos, y/o materiales,
                y/o acciones y/o servicios prestados por los mismos, ni por daños
                y/o pérdidas ocasionadas a los usuarios por su utilización, sean
                causadas directa o indirectamente. La presencia de enlaces a otros
                sitios web no implica una sociedad, relación, aprobación ni
                respaldo de la Sociedad, ni de sus sociedades vinculadas o
                controladas con los titulares de dichos sitios o contenidos.
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </li>
          </ol>
        </li>
        <li data-list-text={20}>
          <h1
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Empleados de Digipayments
          </h1>
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Los empleados en relación de dependencia de Digipayments podrán
            utilizar el Sitio Web siguiendo estrictamente estos T&amp;C. Se
            entenderá que hacen uso del Sitio Web con propósitos personales y bajo
            ningún concepto en nombre de Digipayments ni ninguna de sus sociedades
            vinculadas o controladas. Por este motivo, ni Digipayments ni ninguna
            de sus sociedades vinculadas o controladas se responsabilizan por los
            contactos que éstos realicen. Los empleados de Digipayments están
            sujetos a estos T&amp;C en las mismas condiciones que cualquier
            usuario del Sitio Web. Para utilizar el Sitio Web, sus empleados deben
            consignar su dirección de e-mail y domicilio personales y no las de su
            empleo en Digipayments.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text={21}>
          <h1
            style={{
              paddingLeft: "25pt",
              textIndent: "-20pt",
              textAlign: "justify"
            }}
          >
            Baja del Sitio Web. Falta de Responsabilidad.
          </h1>
          <p
            style={{
              paddingTop: "1pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            El usuario acepta que Digipayments S.A. podrá, en cualquier momento y
            sin necesidad de preaviso, interrumpir, suspender, discontinuar,
            eliminar o modificar el Sitio Web y cualquier producto o Servicio
            ofrecido, mediante decisión fundada.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Digipayments no será responsable por la insolvencia de las entidades
            financieras en las que se encuentren depositados los fondos de las
            Cuentas de Pago, ni por la insolvencia de los terceros cuyos servicios
            hayan sido contratados para prestar los Servicios.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text={22}>
          <h1
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Misceláneas
          </h1>
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            En caso de que una o más cláusulas de estos T&amp;C se declarasen
            nulas por cualquier autoridad u órgano judicial competente, tal
            nulidad no afectará la validez de las restantes cláusulas, que
            mantendrán su plena vigencia y efecto.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            El usuario entiende y acepta que cualquier falta de acción por parte
            de Digipayments respecto del incumplimiento o violación por parte del
            usuario de una o más disposiciones de los presentes T&amp;C no implica
            la conformidad de Digipayments con tal actitud, ni impide que la
            persiga o que en el futuro persiga otra violación idéntica o similar.
            Asimismo, el usuario entiende y acepta que el hecho de que cualquier
            funcionalidad del Sitio Web esté efectivamente disponible, aunque no
            esté mencionada en estos T&amp;C, no dará derecho al usuario al
            mantenimiento de la funcionalidad ni a indemnización alguna en caso de
            su discontinuación con o sin previo aviso.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text={23}>
          <h1
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Cesión
          </h1>
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Digipayments podrá ceder a cualquiera de sus empresas vinculadas o a
            un tercero su posición contractual, este contrato y/o cualquiera de
            los derechos y obligaciones emergentes del mismo. El usuario presta,
            en este acto, su consentimiento para todas y cualquiera de las
            operaciones antedichas.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            A menos que medie consentimiento expreso y por escrito de un
            representante debidamente autorizado de Digipayments, el usuario no
            podrá ceder a ningún tercero su posición contractual, este contrato,
            ni cualquiera de los derechos u obligaciones emergentes del mismo.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text={24}>
          <h1
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Consentimiento para notificaciones electrónicas
          </h1>
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            El usuario otorga su expreso consentimiento para que toda información
            relacionada con su calidad de usuario, su Cuenta y el uso del Sitio
            Web y/o de los Servicios, le sea notificada o informada al último
            correo electrónico informado por él, notificaciones en el Sitio Web
            y/o cualquier otro medio que implique una notificación fehaciente por
            medios electrónicos.
          </p>
        </li>
        <li data-list-text={25}>
          <h1
            style={{
              paddingTop: "1pt",
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Resolución de conflictos. Jurisdicción y ley aplicable
          </h1>
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Los T&amp;C se encuentran regidos sin excepción y en todos sus puntos
            por las leyes de la República Argentina y serán interpretados de
            acuerdo con ellas.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Ante cualquier diferencia, desacuerdo o conflicto derivado del uso de
            los Servicios, o de la aplicación, interpretación, validez o alcance
            de los presentes T&amp;C, el usuario podrá iniciar su reclamo a través
            de los medios previstos en el Sitio Web, o en su defecto a comunicarse
            con Digipayments de manera fehaciente, haciéndole llegar su reclamo,
            para que las partes traten de llegar a un acuerdo antes de iniciar
            cualquier reclamo ante la jurisdicción que le corresponda.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text={26}>
          <h1
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Sugerencias, opiniones, quejas y comentarios
          </h1>
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Todas las sugerencias, opiniones, quejas y comentarios que realice el
            usuario por cualquier medio podrán ser tenidos en cuenta,
            implementados, difundidos o adaptados por Digipayments, sin que ello
            genere derecho alguno a favor del usuario que los haya efectuado o
            propuesto.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text={27}>
          <h1
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Atención al usuario
          </h1>
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            <a
              href="mailto:soporte@digipayments.com.ar"
              className="a"
              target="_blank"
              rel="noreferrer"
            >
              Digipayments cuenta con un centro de atención al usuario. Para
              contactarse por correo electrónico a{" "}
            </a>
            soporte@digipayments.com.ar y/o cualquier otro medio dispuesto por la
            Digipayments a tal fin.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text={28}>
          <h1
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Notificaciones
          </h1>
        </li>
      </ol>
      <p
        style={{
          paddingTop: "2pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "justify"
        }}
      >
        Todas las notificaciones y/o comunicaciones que deban efectuarse a
        Digipayments por los Servicios bajo estos T&amp;C deberán realizarse por
        escrito a su correo electrónico o correo postal indicados a continuación:
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "center"
        }}
      >
        Digipayments S.A.U. CUIT: 30-71695178-9
      </p>
      <p
        style={{
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "center"
        }}
      >
        Dirección: Calle 11 Nro. 559 (entre 43 y 44) , Localidad y Partido de La
        Plata, Pcia. de Buenos Aires.
      </p>
      <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "center" }}>
        <a
          href="mailto:soporte@digipayments.com.ar"
          className="a"
          target="_blank"
          rel="noreferrer"
        >
          Correo electrónico:{" "}
        </a>
        <a href="mailto:soporte@digipayments.com.ar" target="_blank" rel="noreferrer">
          soporte@digipayments.com.ar
        </a>
      </p>
      <p style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "center" }}>
        <span />
      </p>
      <table border={0} cellSpacing={0} cellPadding={0} style={{ marginRight: "auto", marginLeft: "auto" }}>
        <tbody>
          <tr>
            <td>
              <img
                width={150}
                height={109}
                src="data:image/jpg;base64,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"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <p />
      <p style={{ textIndent: "0pt", textAlign: "center" }}>
        <br />
      </p>
      <p
        style={{
          paddingTop: "2pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "center"
        }}
      >
        Bruno Figueiredo Acorsi Director Digipayments S.A.U.
      </p>
      <p
        style={{
          paddingTop: "1pt",
          textIndent: "0pt",
          textAlign: "center"
        }}
      >
        CONSENTIMIENTO INFORMADO
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "justify"
        }}
      >
        Por medio del presente, en mi carácter de TITULAR DE LOS DATOS presto mi
        CONSENTIMIENTO para que DIGIPAYMENTS S.A.U. en su carácter de CESIONARIO
        confronte mis datos personales que se indican en párrafo siguiente con la
        base de datos del RENAPER, conforme a las especificaciones que a
        continuación se detallan:
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}>
        DATOS AUTORIZADOS:
      </p>
      <p
        style={{
          paddingTop: "2pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "justify"
        }}
      >
        El presente consentimiento para el tratamiento de mis datos personales
        alcanza a los incluidos en mi Documento Nacional de Identidad en confronte
        con lo que informa el web service del REGISTRO NACIONAL DE LAS PERSONAS.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}>
        INFORMACIÓN SOBRE EL TRATAMIENTO:
      </p>
      <ol id="l6">
        <li data-list-text={1}>
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Los datos serán tratados con la exclusiva finalidad de validar mi
            identidad y verificar la vigencia de mi Documento Nacional de
            Identidad a los fines de verificar diferentes datos personales para
            prestar servicios de billetera virtual, para el procesamiento de pagos
            y para cumplimentar con lo dispuesto por la Unidad de Información
            Financiera (UIF) en la resolución 76/2019 art. 23 y 24 .
          </p>
        </li>
        <li data-list-text={2}>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Los datos confrontados serán destruidos una vez verificada la validez
            del Documento Nacional de Identidad y validada la misma, no pudiendo
            ser almacenados.
          </p>
        </li>
        <li data-list-text={3}>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            Los datos son facilitados con carácter obligatorio, por cuanto es
            imprescindible identificar fehacientemente al titular, para asegurar
            el correcto proceso de identificación.
          </p>
        </li>
        <li data-list-text={4}>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            El titular de los datos podrá ejercer los derechos de acceso,
            rectificación y supresión de sus datos en cualquier momento y a su
            sola solicitud ante el RENAPER.
          </p>
        </li>
        <li data-list-text={5}>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "114%",
              textAlign: "justify"
            }}
          >
            En cumplimiento de la Resolución AAIP Nº 14/2018, le hacemos saber que
            la AGENCIA DE ACCESO A LA INFORMACIÓN PÚBLICA, en su carácter de
            Órgano de Control de la Ley N° 25.326, tiene la atribución de atender
            las denuncias y reclamos que interpongan quienes resulten afectados en
            sus derechos por incumplimiento de las normas vigentes en materia de
            protección de datos personales.
          </p>
        </li>
      </ol>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
      <a href="/Resumen Terminos y Condiciones Generales.pdf" target='_blank' style={{ textDecoration: 'none', color: 'blue' }}>
          [ Ver Resumen ]
      </a>
      </div>
    </div>
    <Background/>
    </>
  )

export default TermAndConditions;